import { sendEmail } from '@/services/email'

const DEFAULT_RECIPIENT = 'recup-leads@ubiflow.net'

export const LEAD_MAIL_BY_COMPONENT = {
  OptimizeBroadcast: {
    subject: "Nouvelle demande d'activation d''une règle de diffusion depuis l'Espace Client",
    buildContent: (advertiserLogin) =>
      `L'annonceur ${advertiserLogin} a demandé à être recontacté depuis son Espace Client concernant l'activation d'une règle de diffusion de ses annonces. Merci de le recontacter.`
  },
  SocialPostsList: {
    subject: "Nouvelle demande sur le produit Social Manager depuis l'Espace Client",
    buildContent: (advertiserLogin) =>
      'Bonjour,\n' +
      `Vous avez reçu une nouvelle demande de sollicitation concernant le produit Social Manager de la part de l'annonceur ${advertiserLogin}\n` +
      'Ce client est à recontacter.\n' +
      'Bonne journée,'
  }
}

function getDefaultRecipient () {
  if (typeof processEnvConfig !== 'undefined' && processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING) {
    return processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
  }
  return DEFAULT_RECIPIENT
}

export function buildLeadMailData ({ advertiserLogin, component, to, subject, content, email_content: emailContent } = {}) {
  const mailData = {
    to: to || getDefaultRecipient()
  }
  const body = emailContent !== undefined ? emailContent : content

  if (component && LEAD_MAIL_BY_COMPONENT[component]) {
    const leadConfig = LEAD_MAIL_BY_COMPONENT[component]
    mailData.subject = subject || leadConfig.subject
    mailData.email_content = body || leadConfig.buildContent(advertiserLogin)
  } else {
    if (!subject || body === undefined) {
      throw new Error('sendLeadMail requires either a component or both subject and content')
    }
    mailData.subject = subject
    mailData.email_content = typeof body === 'function' ? body(advertiserLogin) : body
  }

  return mailData
}

export async function sendLeadMail (options = {}) {
  const mailData = buildLeadMailData(options)
  return sendEmail(mailData)
}
